import { DOCUMENT, inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";

/**
 * Sends the user to a page outside this app and blocks the route from activating.
 * Query params and fragment from the requested route are carried over.
 *
 * Root-relative urls resolve against the current origin, so they follow the
 * environment (www-t in test, www in prod). Uses `replace` so the back button
 * doesn't return the user to the redirecting route.
 */
export function redirectToExternalUrlGuard(url: string): CanActivateFn {
  return (route) => {
    // Read from the snapshot, not window.location: on in-app navigation the
    // browser url has not been updated yet when guards run.
    const queryParams = new URLSearchParams();
    for (const key of route.queryParamMap.keys) {
      for (const value of route.queryParamMap.getAll(key)) {
        queryParams.append(key, value);
      }
    }

    const query = queryParams.toString();
    const separator = url.includes("?") ? "&" : "?";
    const fragment = route.fragment ? `#${route.fragment}` : "";

    inject(DOCUMENT).location.replace(`${url}${query ? separator + query : ""}${fragment}`);

    return false;
  };
}
